import { Route } from 'react-router-dom';

import PageNotFound from './components/PageNotFound';

export default {
  routes: [<Route path="*" key="pageNotFound" exact component={PageNotFound} />],
};
